export default __webpack_public_path__ + "static/media/Avalanche (1).bf2f6cd0.svg";